/* eslint-disable no-console */
import {
  LetterbookSettingType,
  LetterbookType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import ColumnComponents from "./ColumnComponents";

export default function LetterbookColumn({
  column,
  letterbook,
  settings,
}: {
  column: LetterlistTableColumnSettingType;
  letterbook: LetterbookType;
  settings: LetterbookSettingType;
}) {
  const ColumnComponent = ColumnComponents[column.key];

  // Hopefully never happens 😅
  if (!ColumnComponent) {
    console.log(`Column does not exist: ${column.key}`);
    return false;
  }

  return <ColumnComponent letterbook={letterbook} settings={settings} />;
}
